import React from "react";
import { Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import PrototypeEmbed from "./pages/PrototypeEmbed";
import RemoveTrailingSlash from "./hooks/removeTrailingSlash";
import prototypeRoutes from "./config/prototypeRoutes";

function App() {
  return (
    <div className="App">
      <RemoveTrailingSlash />
      <Routes>
        <Route path="/" element={<Home />} />
        {prototypeRoutes.map(({ path, source, title }) => (
          <Route
            key={path}
            path={path}
            element={<PrototypeEmbed source={source} title={title} />}
          />
        ))}
      </Routes>
    </div>
  );
}

export default App;
